import { Col, Row, Input, Form, Select, Avatar, Switch, Space, Table } from 'antd'
import styles from '../styles.module.scss'
import { useContext, useEffect, useState } from 'react'
import Context from '../../Context'
import find from 'lodash/find'
import BaseLayout from 'components/BaseLayout'
import { VscWorkspaceTrusted } from "react-icons/vsc";
import { RoleInterface } from 'containers/Admin/Roles/contextTypes'
// helpers
import get from 'lodash/get'
import map from 'lodash/map'
import flatMap from 'lodash/flatMap'
import isEmpty from 'lodash/isEmpty'

const { Option } = Select


const UpdateUserInfo: React.FC<{ form: any }> = ({ form }) => {
  const {
    states: { selectedUser, roles, type },
    queryHandler: { data }
  } = useContext(Context)

  const role: RoleInterface =
    find(data, ({ id }) => selectedUser === id) ?? {}


  return (
    <BaseLayout className="updateUserCard">
      <div className={styles.updateUser}>
        <Row>
          <Col>
            <div className="modalChild">
              <h2>{type === 'updateUser' ? 'Actualizar información del rol' : 'Crear nuevo rol'}</h2>
              <Avatar
                className="img"
                icon={<VscWorkspaceTrusted style={{ fontSize: '5.5rem' }} />}
                style={{
                  display: 'flex',
                  width: '7rem',
                  height: '7rem',
                  alignItems: 'center',
                  justifyContent: 'center',
                  backgroundColor: '#1E99E1'
                }}
              />
              <Form
                form={form}
                layout="vertical"
                style={{ width: 340 }}
                initialValues={{
                  name: role.name,
                  description: role.description
                }}
              >

                <Form.Item
                  label="Nombre"
                  name="name"
                  rules={[
                    { required: true, message: 'Nombre es un campo requerido' }
                  ]}
                >
                  <Input placeholder="Admin" />
                </Form.Item>
                <Form.Item
                  className='textArea'
                  label="Descripcion"
                  name="description"
                  rules={[
                    {
                      required: true,
                      message: 'Descripcion es un campo requerido'
                    }
                  ]}
                >
                  <Input.TextArea placeholder="Rol admin" />
                </Form.Item>



              </Form>
            </div>
          </Col>
        </Row>
      </div>
    </BaseLayout>
  )
}

export default UpdateUserInfo
